// Novità: stessa pagina del Catalogo (grafica, filtri, scheda prodotto, carrello),
// con i soli prodotti segnati come nuovi.
import React from 'react';
import Catalogo from './Catalogo';

const NewArrivals = (props) => <Catalogo {...props} variant="new" />;

export default NewArrivals;
